import TableExport from 'tableexport'

// A TableExport identifica tabelas sem `id` com um contador global ao módulo
// (`tableexport-1`, `tableexport-2`, ...) que só zera em recarga completa da
// página. Após uma navegação Turbolinks a tabela recém-renderizada recebe um
// número novo, então a chave precisa ser lida do elemento em vez de fixada.
export const buildTableExport = (settings = {}) => {
  const table = TableExport(document.getElementsByTagName('table'), {
    exportButtons: false,
    formats: ['xlsx'],
    ...settings
  })

  const [firstTable] = table.selectors
  const exportData = table.getExportData()[firstTable.getAttribute(table.tableKey)]

  return { table, exportData }
}
